import { Button } from "@ingka/button-webc/passive.js";
import { Scrollbar } from "./elements/Scrollbar.js";
import { CarouselBase } from "./CarouselBase.js";
import { SlideShowFeature } from "./features/slide-show.js";
import { SkipListingFeature } from "./features/skip-listing.js";
import { ScrollbarHandlerFeature } from "./features/scrollbar-handler.js";
const styles = ':host{--carousel-container-vertical-padding:0.5rem;display:block;max-width:100%;position:relative}@supports (scroll-margin-inline-start:0.5rem){:host(:not([slide-show])) ::slotted(*){scroll-margin-inline-start:.5rem}}.wrapper{box-sizing:border-box;display:flex;flex-wrap:nowrap;margin-bottom:calc(var(--carousel-container-vertical-padding)*-1);margin-top:calc(var(--carousel-container-vertical-padding)*-1);margin-inline-end:calc(var(--skapa-carousel-overflow-end, 0)*-1);margin-inline-start:calc(var(--skapa-carousel-overflow-start, 0)*-1);overflow-x:scroll;overscroll-behavior-inline:none;padding-bottom:var(--carousel-container-vertical-padding);padding-top:var(--carousel-container-vertical-padding);scrollbar-width:none;width:calc(100% + var(--skapa-carousel-overflow-start, 0rem) + var(--skapa-carousel-overflow-end, 0rem))}.wrapper::-webkit-scrollbar{display:none}.wrapper:after,.wrapper:before{content:"";display:block;flex:0 0 var(--skapa-carousel-overflow-start,0)}.wrapper:after{flex:0 0 var(--skapa-carousel-overflow-end,0)}#slides::slotted(:not(:first-of-type)){margin-inline-start:var(--skapa-carousel-item-gap,1.25rem)!important}#slides::slotted(*){flex-shrink:0}#slides::slotted(img){object-fit:contain;pointer-events:none;user-select:none}:host([auto-slide-size]) #slides::slotted(*),:host([slide-show]) #slides::slotted(*){flex:0 0 calc((100% - var(--skapa-carousel-overflow-end, 0rem) - var(--skapa-carousel-overflow-start, 0rem) - (var(--visible-item-count, 1) - 1)*var(--skapa-carousel-item-gap, 1.25rem))/var(--visible-item-count, 1));width:calc((100% - var(--skapa-carousel-overflow-end, 0rem) - var(--skapa-carousel-overflow-start, 0rem) - (var(--visible-item-count, 1) - 1)*var(--skapa-carousel-item-gap, 1.25rem))/var(--visible-item-count, 1))}.controls{position:absolute;transition:opacity .2s cubic-bezier(.4,0,.4,1);z-index:2}.controls::part(control-button){box-shadow:0 4px 16px #0000001a}slot[name=skip-button]{display:inline-block;margin-inline-start:1.5rem;opacity:0;pointer-events:none;position:absolute;top:1.5rem;z-index:2}slot[name=skip-button]:focus-within{opacity:1;pointer-events:all}.scrollbar{margin-top:.5rem}.controls{top:calc(50% - 1.25rem)}:host(:not(:hover)) .controls{opacity:0}:host([slide-show]) .controls{--skapa-carousel-control-offset:2rem;display:block}:host([slide-show]) .wrapper.manual-scroll{scroll-snap-type:x mandatory}:host([slide-show]) .wrapper #slides::slotted(*){scroll-snap-align:center}:host([hidden-scrollbar]) .scrollbar{display:none}';
const generateTemplate = ({ html }) => {
  const template = document.createElement("template");
  template.innerHTML = html`<style>
      ${styles}
    </style>
    <slot name="skip-button">
      <skapa-button id="btn-skip" inverse
        ><slot name="skip-label">Skip listing</slot></skapa-button
      >
    </slot>
    <div class="wrapper" id="scroll-container" part="container">
      <slot id="slides"></slot>
    </div>
    <skapa-carousel-scrollbar
      class="scrollbar"
      part="scrollbar"
    ></skapa-carousel-scrollbar>
    <skapa-carousel-controls
      class="controls"
      aria-hidden="true"
      exportparts="control-button"
    ></skapa-carousel-controls>
    <div id="skiplisting" tabindex="-1"></div> `;
  return { main: template };
};
class Carousel extends CarouselBase {
  constructor() {
    super(generateTemplate);
    this.features.scrollbarHandler = new ScrollbarHandlerFeature(
      this,
      this.shadow.querySelector(
        this.getPrefixedTagName(Scrollbar.skapaTagName)
      )
    );
    this.featuresList.push(this.features.scrollbarHandler);
    this.features.slideShow = new SlideShowFeature(this);
    this.featuresList.push(this.features.slideShow);
    this.features.skipListing = new SkipListingFeature(this);
    this.featuresList.push(this.features.skipListing);
    this.rawScrollToSlide = this.scrollToSlide;
    this.scrollToSlide = (slide, offsetPercent = 0, padding = 0) => {
      this.features.slideShow.setManualMode();
      this.rawScrollToSlide(
        slide,
        this.slideShow ? 0.5 : offsetPercent,
        padding
      );
    };
  }
}
Carousel.skapaTagName = "carousel";
Carousel.skapaDependencies = [
  ...CarouselBase.skapaDependencies,
  Scrollbar,
  Button
];
export {
  Carousel
};
